export const colorPrimitives = {
  black: {
    1: '#25262b', // deep
    2: '#221E1F', // darker
  },
  gray: {
    1: '#f2f2f4', // very light
    2: '#e8ebf4', // soft off-white
    3: '#d7dbe7', // light cool
    4: '#e0e2ef', // light neutral
    5: '#686a77', // mid
    6: '#595657', // muted
    7: '#303644', // soft
    8: '#272b36', // medium
    9: '#232730', // dark
    10: '#20242d', // deepest
  },
  yellow: {
    1: '#ffc547', // vibrant
    2: '#f8b55e', // light orange-yellow
    3: '#e7c53a', // golden
    4: '#f3c74a', // muted
  },
  green: {
    1: '#66C770', // success (single entry, already light)
  },
  blue: {
    1: '#36dee9', // bright
    2: '#67b6be', // soft
  },
  orange: {
    1: '#f5984b', // warning (single entry, already light)
  },
  red: {
    1: '#ef6970', // danger (single entry, already light)
  },
  white: {
    1: '#FFFFFF', // pure (single entry, already light)
  },
  neutral: {
    1: '#f2f2f4', // very light
    2: '#e8ebf4', // soft off-white
    3: '#d7dbe7', // light cool
    4: '#e0e2ef', // light neutral
  },
};
